import { render, staticRenderFns } from "./PromptColor.vue?vue&type=template&id=17ce3a2a&scoped=true&"
import script from "./PromptColor.vue?vue&type=script&lang=js&"
export * from "./PromptColor.vue?vue&type=script&lang=js&"
import style0 from "./PromptColor.vue?vue&type=style&index=0&id=17ce3a2a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ce3a2a",
  null
  
)

export default component.exports